// extracted by mini-css-extract-plugin
module.exports = {"selectedPlanSummary":"_3_6bw_","note":"NKRzEr","noteTitle":"_1iBQLc","buttons":"_2tm_54","button":"_1RMVU_","attention":"_1JQHR_"};